
import { toCapitalized } from '@fixit/utils';
import {MarkerDetails} from '../models/GeoLocation'
import SearchResultListItemDetails from './SearchResultListItemDetails.vue';

export default {
    name: 'search-map-info-window-card',
    components: { SearchResultListItemDetails },
    props: {
        category: Number,
		treatment: Number,
		datetime: String,
        salon: {
            type: Object,
            default: null
        },
        isMobile: Boolean
    },
    computed: {
        salonDetails() {return new MarkerDetails(this.salon) },
        mapIsFullscreen() { return false },
        salonImage() {
            return this.$store.getters['cmsConfigHomepage/getSites'].filter(x => x.siteId == this.salon.siteId)[0].salonImageUrl
        }
    },
    methods: {
         navigateToUrl() {
            this.$router.push(`/about/${this.salon.urlFrendlyLink}`);
          },
          salonDistance(distance) {
            if (distance != null && distance != undefined && distance != NaN && distance != 0 && distance != '') {
              if (distance < 1) {
                return Math.round(distance*1000) + ' meter unna';
              } else if (distance >= 1 && distance <= 100) {
                return distance.toFixed(1) + ' kilometer unna';
              } else if (distance > 100) {
                return Math.round(distance) + ' kilometer unna';
              }
            } else {
              return ''
            }
          },
    },
    data() {
        return {
            show: false
        }
    },
    filters: {
        capitalize: toCapitalized
    }
}
